import get from "lodash/get";

export const redirectFromLogin = (navigate, location) => {
  const redirectPath = get(location, "state.redirectPath", null);

  if (redirectPath && redirectPath !== "/login") {
    return navigate(redirectPath);
  }

  navigate("/");
};
